// src/utils/storage.ts

// Supabase Storage (backend S3-compatible) rejette les clés d'objet contenant
// certains caractères (accents, apostrophes, espaces...) avec une erreur 400.
// On assainit donc le nom de fichier avant de construire le chemin de stockage,
// tout en gardant l'extension d'origine.
export function sanitizeFileName(name: string): string {
  const lastDot = name.lastIndexOf(".");
  const base = lastDot > 0 ? name.slice(0, lastDot) : name;
  const ext = lastDot > 0 ? name.slice(lastDot + 1) : "";

  const cleanBase = base
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // supprime les accents
    .replace(/[^a-zA-Z0-9._-]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_+|_+$/g, "") || "file";

  const cleanExt = ext
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "");

  return cleanExt ? `${cleanBase}.${cleanExt}` : cleanBase;
}
